import { UnlockedTextProps } from './types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, Node } from '@contentful/rich-text-types';

const UnlockedText = ({ unlockedText }: UnlockedTextProps) => {
  return documentToReactComponents(unlockedText.json, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node: Node, children: React.ReactNode) => (
        <span className={`font-unlocked font-normal`}>{children}</span>
      ),
    },
  });
};

export default UnlockedText;
